import { useCallback, useEffect } from 'react';
import { useNavigate, matchPath, useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { PagePath } from '@/routes/paths';
import useStore from '@/stores/sider-menu';
import MenuIcon from '@/layouts/main-layout/components/menu-icon';
import MenuItem from '@/layouts/main-layout/components/menu-item';

// const ComandTip = ({ children }: { children: React.ReactNode }) => {
//   return (
//     <div className="bg-[#E5E5E5]/60 w-4 h-4 rounded group-hover:bg-[#E5E5E5]/45 text-[10px] text-[#797689] font-semibold flex items-center justify-center">
//       {children}
//     </div>
//   );
// };

export default function NewRequest() {
  const { collapsed } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = !!matchPath(PagePath.home, location.pathname);

  const handleClick = useCallback(() => {
    navigate(PagePath.home);
  }, [navigate]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const isTriggerKey = event.key.toLowerCase() === 'k' && (event.metaKey || event.ctrlKey);
      if (!isTriggerKey) {
        return;
      }

      const target = event.target as HTMLElement | null;
      const tagName = target?.tagName?.toLowerCase();
      if (target?.isContentEditable || tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
        return;
      }

      event.preventDefault();
      handleClick();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleClick]);

  if (collapsed) {
    return (
      <MenuIcon title="New Request" onClick={handleClick} isActive={isActive}>
        <Plus size={16} color="#737373" />
      </MenuIcon>
    );
  }

  return (
    <MenuItem
      className={isActive ? 'bg-[#E5E5E5]/65' : ''}
      onClick={handleClick}
      icon={<Plus size={16} color="#737373" />}
      // append={
      //   <div className="flex items-center gap-1">
      //     <ComandTip>
      //       <Command size={10} />
      //     </ComandTip>
      //     <ComandTip>K</ComandTip>
      //   </div>
      // }
    >
      New Request
    </MenuItem>
  );
}
